import React from 'react'
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { toAbsoluteUrl } from "../../../Utils/_helpers";
import { Tracker } from "../../util/analytics";
import { getCustomerAsValues } from "../../util/getCustomer";
import * as helpers from "../../util/helpers";
import { actionTypes as actionTypesAuth } from "../Auth/_redux/authRedux";
import * as c2cConstants from "./constants";
import * as constants from "./constants";
import { actionTypes, REQ_STATE } from "./reducer";

export const CallMenuList = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const setViewState = (view_state) => {
    dispatch({
      type: actionTypes.onCallViewState,
      payload: {
        view_state: view_state,
        previous_view_state: props.callFlow.state.view_state,
      },
    });
  };

  return (
    <div className="row justify-content-center cc-call-actions">
     
      <div className="update-action">
      {((!helpers.isNumberMaskingEnabled() && (helpers.isAgent() || helpers.isSuperVisor())) || helpers.isAdmin()) &&
        <a
          href="/#"
          onClick={(e) => {
            e.preventDefault();
            setViewState(constants.CALL_VIEW_STATES.CALL_ADD_CUSTOMER);
            Tracker.event(
              c2cConstants.ANALYTICS.C2C_ADD_CUST[0],
              c2cConstants.ANALYTICS.C2C_ADD_CUST[1],
              c2cConstants.ANALYTICS.C2C_ADD_CUST[2],
              c2cConstants.ANALYTICS.C2C_ADD_CUST[3],
              helpers.getUser()
            );
          }}
        >
          <div className="action-indicator">
            <img
              alt=""
              className="dial-call-icon"
              src={toAbsoluteUrl("/media/sr/icons/call-update.svg")}
            />
          </div>
          <div className="action-text">Add/Update</div>
        </a>}
      </div>
      {!props.callFlow.state.hide_tc && (
        <div
          className={`${
            props.tc_disabled ? "action-disabled" : ""
          } transfer-action`}
        >
          <a
            href="/#"
            className={`${props.tc_disabled ? "action-disabled" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              if (props.callFlow.state.transfer_state === REQ_STATE.CONNECTED) {
              } else {
                setViewState(constants.CALL_VIEW_STATES.CALL_ADD_TRANSFER_VIEW);
                Tracker.event(
                  c2cConstants.ANALYTICS.C2C_CALL_TRANSFER[0],
                  c2cConstants.ANALYTICS.C2C_CALL_TRANSFER[1],
                  c2cConstants.ANALYTICS.C2C_CALL_TRANSFER[2],
                  c2cConstants.ANALYTICS.C2C_CALL_TRANSFER[3],
                  helpers.getUser()
                );
              }
            }}
          >
            <div className="action-indicator">
              <img
                alt=""
                className="dial-call-icon"
                src={toAbsoluteUrl("/media/sr/icons/call-transfer.svg")}
              />
            </div>
            <div className="action-text">Transfer</div>
          </a>
        </div>
      )}
      {!props.callFlow.state.hide_tc && (
        <div
          className={`${
            props.tc_disabled ? "action-disabled" : ""
          } conference-action`}
        >
          <a
            href="/#"
            className={`${props.tc_disabled ? "action-disabled" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              if (props.callFlow.state.transfer_state === REQ_STATE.CONNECTED) {
              } else {
                setViewState(
                  constants.CALL_VIEW_STATES.CALL_ADD_CONFERENCE_VIEW
                );
                Tracker.event(
                  c2cConstants.ANALYTICS.C2C_CALL_CONF[0],
                  c2cConstants.ANALYTICS.C2C_CALL_CONF[1],
                  c2cConstants.ANALYTICS.C2C_CALL_CONF[2],
                  c2cConstants.ANALYTICS.C2C_CALL_CONF[3],
                  helpers.getUser()
                );
              }
            }}
          >
            <div className="action-indicator">
              <img
                alt=""
                className="dial-call-icon"
                src={toAbsoluteUrl("/media/sr/icons/call-conference.svg")}
              />
            </div>
            <div className="action-text">Conference</div>
          </a>
        </div>
      )}
      {props.callFlow.state.customer && props.callFlow.state.customer.id && (
        <div className="history-action">
          <a
            href="/#"
            onClick={(e) => {
              e.preventDefault();
              const crmCustomer = getCustomerAsValues(
                props.callFlow.state.customer
              );
              dispatch({
                type: actionTypesAuth.Set,
                payload: {
                  changelog: {
                    crmCustomer: crmCustomer,
                    crmCustomerId: crmCustomer.id,
                  },
                },
              });
              history.push("/customer-management/customer");
              dispatch({
                type: actionTypes.onCallViewState,
                payload: {
                  window_state: constants.C2C_CONSTANTS.WINDOW_STATE_MINIMIZED,
                },
              });

              Tracker.event(
                c2cConstants.ANALYTICS.C2C_VIEW_HIST[0],
                c2cConstants.ANALYTICS.C2C_VIEW_HIST[1],
                c2cConstants.ANALYTICS.C2C_VIEW_HIST[2],
                c2cConstants.ANALYTICS.C2C_VIEW_HIST[3],
                helpers.getUser()
              );
            }}
          >
            <div className="history-action">
              <div className="action-indicator">
                <img
                  alt=""
                  className="dial-call-icon"
                  src={toAbsoluteUrl("/media/sr/icons/call-history.svg")}
                />
              </div>
              <div className="action-text">View History</div>
            </div>
          </a>
        </div>
      )}
    </div>
  );
};
